import { useApiFetch } from "hooks/useApiFetch";
import { createContext, ReactNode, useEffect, useState } from "react";

type FormUrlType = {
    formUrl: string;
};

export const NominationFormUrlContext = createContext<FormUrlType>({
    formUrl: ""
});

export function NominationFormUrlProvider({ children }: { children: ReactNode }) {
    const { apiGet } = useApiFetch();

    const [nominationFormUrlState, setNominationFormUrlState] =
        useState<FormUrlType>({
            formUrl: ""
        });

    useEffect(() => {
        apiGet({
            path: `MapForIwi/GetSiteNominationFormUrl`,
            onSuccess: (data) =>
                setNominationFormUrlState({
                    formUrl: data.url
                }),
        });
    }, []);

    return (
        <NominationFormUrlContext.Provider value={nominationFormUrlState}>
            {children}
        </NominationFormUrlContext.Provider>
    );
}